type Props = {
  children?: React.ReactNode;
};

const Table = ({ children }: Props) => {
  return (
    <table className="shadow border-b border-faux-ceiling-bright-white min-w-full divide-y divide-white dark:text-gray-300 dark:divide-gray-700">
      {children}
    </table>
  );
};

export default Table;
